<template>
    <review-component v-bind="$props" v-on="$listeners">
        <component :is="componentTag" class="text">
            &#60;{{componentTag}}&#62;
            <span v-html="component.getText(displayLanguage)"/>
            &#60;/{{componentTag}}&#62;
        </component>
    </review-component>
</template>

<script>
import ReviewComponent from "@components/review/review-component.vue";

export default {
    name: `review-component-text`,
    extends: ReviewComponent,
    components: {ReviewComponent},
    computed: {
        componentTag() {
            switch (this.component.mediaProxy.preset) {
                case `p1`:
                case `p2`:
                case `p3`:
                case `p4`:
                case `p5`:
                case `p6`:
                    return `p`;
                case `default`:
                    return `div`;
                default:
                    return this.component.mediaProxy.preset;
            }
        }
    }
}
</script>

<style lang="scss">
.review-component-text {
    h1, h2, h3, h4, h5, h6, h7, h8 {
        font-size: 1rem !important;
        letter-spacing: 0 !important;
        font-weight: 500 !important;
    }
    h1 {
        font-size: 1.4rem !important;
    }
    h2 {
        font-size: 1.3rem !important;
    }
    h3 {
        font-size: 1.2rem !important;
    }
    h4 {
        font-size: 1.1rem !important;
    }
    h5 {
        font-size: 1.05rem !important;
    }

    .text * {
        font-size: inherit !important;
        font-weight: inherit !important;
    }
}
</style>
